




































































































import { AuthHttp } from "@/mixins/http/auth";
// eslint-disable-next-line no-unused-vars
import { FreeTrialConfig, SignUpConfig } from "@/types/auth";
// eslint-disable-next-line no-unused-vars
import { AxiosResponse } from "axios";
import { Component, Mixins } from "vue-property-decorator";
@Component({})
export default class SignUp extends Mixins(AuthHttp) {
	loading: boolean = false;
	formValid: boolean = false;
	emailAddress: string = "";
	errorMessage: string = "";
	password: string = "";
	emailRules = [
		(inputText: string) => this.isSet(inputText) || "E-mail is required",
		(inputText: any) => /.+@.+/.test(inputText) || "E-mail must be valid",
	];

	passwordRules = [
		(inputText: string) => this.isSet(inputText) || "Password is required",
		(inputText: string) => inputText.length >= 8 || "Password must be 8 letters or longer",
	];

	showVerifyEmailMessage: boolean = false;
	passwordsMatchRules = [
		(inputText: string) => this.isSet(inputText) || "Enter your password again to confirm it",
		(inputText: string) => this.compareToPasswordField(inputText) || "Passwords must match",
	];

	public attemptSignUp(): void {
		this.loading = true;
		let signUpConfig: SignUpConfig = this.constructSignUpConfig();

		this.signUp(signUpConfig)
			.then(() => {
				(this.$refs.form as any).reset();
				this.showVerifyEmailMessage = true;
				this.errorMessage = "";
			})
			.catch((error) => {
				this.errorMessage = this.convertServerError(error.response.data.message);
				this.showVerifyEmailMessage = false;
			})
			.finally(() => {
				this.loading = false;
			});
	}

	constructSignUpConfig(): SignUpConfig {
		let signUpConfig: SignUpConfig = {
			email: this.emailAddress,
			password: this.password,
		};

		if (this.$route.query.priceId) {
			let freeTrialConfig: FreeTrialConfig = {
				priceId: this.$route.query.priceId.toString(),
			};

			signUpConfig.freeTrial = freeTrialConfig;
		} else {
			delete signUpConfig.freeTrial;
		}

		return signUpConfig;
	}

	public get canAttemptSignUp(): boolean {
		return this.formValid;
	}

	private isSet(text: string): boolean {
		return text != undefined && text != null && text != "";
	}

	private compareToPasswordField(confirmPasswordText: string) {
		return confirmPasswordText == this.password;
	}

	private convertServerError(errorMessage: string): string {
		return errorMessage;
	}
}
